export {
    default,
    type YearParticipantsSectionRawProps,
    type YearParticipantsSectionItem,
} from './YearParticipantsSection';
